import ic_arrow_up from '../assets/images/ic_arrow_up.png'
import ic_arrow_down from '../assets/images/ic_arrow_down.png'
import {useState} from 'react'

type TypeInputList = any[]

export const useTag = () => {
    const renderNetworkColor = network => {
        const bgColor = () => {
            switch (network) {
                case 'gmail':
                    return 'bg-[#f4e0e0] text-font_red'
                case 'kakaotalk':
                    return 'bg-[#f4e7a0] text-[#665111]'
                case 'facebook':
                    return 'bg-sub_blue text-white'
                case 'apple':
                    return 'bg-bg_gray01 text-black'
                case 'coinbase':
                    return 'bg-[#0905b5] text-white'
                case 'binance':
                    return 'bg-[#f9ea80] text-font01'
                case 'email':
                default:
                    return 'bg-line03 text-font03'
            }
        }

        return `text-center w-min py-[2px] px-[8px] text-ti2 rounded-[5px] ${bgColor()}`
    }

    const renderPrivacyLevel = privacy => {
        switch (privacy) {
            case 0:
                return 'Open to Followers'
            case 1:
                return 'Open All'
            case 2:
                return 'Private'
            case 3:
                return 'Spy Mode'
        }
    }

    const renderStateColor = status => {
        if (status) {
            return 'text-center w-min py-[2px] px-[7px] text-ti3 rounded-[5px] text-ti3 text-font_green bg-tag_green_light'
        } else {
            return 'text-center w-min py-[2px] px-[7px] text-ti3 rounded-[5px] text-ti3 text-font_red bg-tag_red_light'
        }
    }

    const renderEventTagColor = status => {
        if (status === 'Live') {
            return 'text-center w-min py-[2px] px-[7px] text-ti3 rounded-[5px] text-ti3 text-white bg-red-500'
        } else if (status === 'none') {
            return 'text-center w-min py-[2px] px-[7px] text-ti3 rounded-[5px] text-ti3 text-gray-500 bg-gray-100 text-font03'
        } else if (status === 'Soon') {
            return 'text-center w-min py-[2px] px-[7px] text-ti3 rounded-[5px] text-ti3 text-white bg-blue-500'
        } else {
            return 'text-center w-min py-[2px] px-[7px] text-ti3 rounded-[5px] text-ti3 text-gray-500 bg-gray-100  text-font03'
        }
    }

    const renderLeverageColor = side => {
        if (side === 'long' || side === 'LONG') {
            return 'bg-primary text-white'
        } else {
            return 'bg-font_red text-white'
        }
    }

    const renderProfitArrow = pnl => {
        if (pnl > 0) {
            return ic_arrow_up
        } else {
            return ic_arrow_down
        }
    }

    const renderProPaymentColor = method => {
        const bgColor = () => {
            switch (method) {
                case 'crypto':
                    return 'bg-tag_blue text-white'
                case 'binance-pay':
                    return 'bg-[#F3BA2F] text-[#665111]'
                case 'mobile':
                default:
                    return 'bg-primary text-white'
            }
        }

        return `text-center w-min py-[2px] px-[8px] text-ti2 rounded-[5px] whitespace-nowrap ${bgColor()}`
    }

    const renderStatusTagColor = status => {
        switch (status) {
            case 'confirmed':
                return 'bg-tag_green_light text-font_green text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
            case 'canceled':
                return 'bg-[#f0eba3] text-[#d57b1a] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
            case 'failed':
                return 'bg-tag_red_light text-font_red text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
            case 'created':
                return 'bg-[#d9f4f5] text-[#7eb0f9] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
            case 'pending':
                return 'bg-[#f2d2f8] text-[#d56ae5] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
            case 'processing':
                return 'bg-[#b9c5ff] text-[#5e60da] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
            default:
                return 'bg-bg_gray01 text-font02 text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
        }
    }

    const renderHistoryTag = status => {
        switch (status) {
            case 'buy':
            case 'income':
            case 'deposit':
                return 'px-[8px] py-[3px] text-center rounded-[5px] bg-tag_green_light text-body_comm text-font_green uppercase'
            case 'sell':
            case 'withdraw':
                return 'px-[8px] py-[3px] text-center rounded-[5px] bg-tag_red_light text-body_comm text-font_red uppercase'
            default:
                return 'px-[8px] py-[3px] text-center rounded-[5px] bg-bg_gray01 text-body_comm uppercase'
        }
    }

    const announcementTagColor = status => {
        switch (status) {
            case 'event':
                return 'bg-tag_blue/40 text-font_green text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
            case 'media':
                return 'bg-[#f0eba3] text-[#d57b1a] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
            case 'announcement':
                return 'bg-[#d9f4f5] text-[#7eb0f9] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
            case 'other':
                return 'bg-[#f2d2f8] text-[#d56ae5] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
            default:
                return 'bg-[#b9c5ff] text-[#5e60da] text-ti3 w-min py-[1px] rounded-[5px] px-[7px]'
        }
    }

    return {
        renderNetworkBgColor: renderNetworkColor,
        renderPrivacyLevel,
        renderStateColor,
        renderLeverageColor,
        renderProfitArrow,
        renderProPaymentColor,
        renderEventTagColor,
        renderStatusTagColor,
        renderHistoryTag,
        announcementTagColor,
    }
}

export const useColor = () => {
    const getNumberColor = num => {
        if (num > 0) {
            return 'text-font_green'
        } else {
            return 'text-font_red'
        }
    }

    return {getNumberColor}
}

export const useInputCheck = () => {
    const [checkList, setCheckList] = useState([])

    const onCheckedFunction = item => {
        if (checkList?.find(list => list === item)) {
            const list = checkList?.filter(e => e !== item)
            setCheckList(list)
        } else {
            setCheckList([...checkList, item])
        }
    }

    const onChangeCheckList = (arr: TypeInputList) => {
        setCheckList(arr)
    }

    const resetCheckList = () => {
        setCheckList([])
    }

    return {checkList, onCheckedFunction, resetCheckList, onChangeCheckList}
}

export const copyToClipboard = async (text: string) => {
    await navigator.clipboard.writeText(text).then(() => {
        alert(`Copy to Clipbpard: ${text}`)
    })
}
